import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, ArrowRight, Clock, Calendar } from 'lucide-react';
import Reveal from './Reveal';
import { formatDate } from '../lib/utils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LatestArticles = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    axios.get(`${API}/content/articles`, { params: { page_size: 3 } })
      .then(({ data }) => setArticles(data.items || []))
      .catch(() => setArticles([]));
  }, []);

  if (articles.length === 0) return null;

  return (
    <section className="section-padding bg-[#FFF9F4]" data-testid="home-latest-articles">
      <div className="container-hm">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-10">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold text-[#FF6B00] uppercase tracking-wide">
              <BookOpen className="w-4 h-4" /> Central de Conteúdos
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mt-2">Últimos conteúdos</h2>
            <p className="mt-2 text-slate-600">Dicas e insights sobre carreira, recrutamento e gestão de pessoas.</p>
          </div>
          <Link to="/conteudos" data-testid="home-articles-viewall" className="inline-flex items-center gap-2 font-semibold text-[#FF6B00] hover:gap-3 transition-all shrink-0">
            Ver todos <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {articles.map((a, idx) => (
            <Reveal key={a.id} variant="fadeUp" delay={Math.min(idx * 80, 240)}>
              <Link to={`/conteudos/${a.slug}`} data-testid={`home-article-${a.slug}`}
                className="flex flex-col h-full rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-xl hover-lift group border border-slate-100">
                <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                  {a.cover_image_url
                    ? <img src={a.cover_image_url} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    : <div className="w-full h-full bg-gradient-to-br from-orange-100 to-orange-50 flex items-center justify-center"><BookOpen className="w-10 h-10 text-orange-300" /></div>}
                </div>
                <div className="p-6 flex flex-col flex-1">
                  {a.category && <span className="text-xs font-bold text-[#FF6B00] uppercase tracking-wide">{a.category}</span>}
                  <h3 className="text-lg font-bold text-slate-900 mt-1.5 line-clamp-2 group-hover:text-[#FF6B00] transition-colors">{a.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-3 flex-1">{a.excerpt}</p>
                  <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between text-xs text-slate-400">
                    <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {formatDate(a.published_at)}</span>
                    <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {a.reading_minutes} min</span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestArticles;
